var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClipboardListCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.125h-3.333C14.667 2.677 13.47 1.5 12 1.5c-1.47 0-2.667 1.177-2.667 2.625H6c-1.104 0-2 .882-2 1.969V20.53c0 1.087.896 1.969 2 1.969h12c1.104 0 2-.882 2-1.969V6.094c0-1.087-.896-1.969-2-1.969zm-6-.984a.99.99 0 0 1 1 .984.99.99 0 0 1-1 .984.99.99 0 0 1-1-.984.99.99 0 0 1 1-.984zm-5.267 6.948.53-.517a.226.226 0 0 1 .316 0l.859.853 1.983-1.936a.226.226 0 0 1 .317 0l.524.521a.218.218 0 0 1 0 .312L8.587 11.93a.226.226 0 0 1-.316 0L6.733 10.4a.218.218 0 0 1 0-.311zM8 17.579a.99.99 0 0 1-1-.985.99.99 0 0 1 1-.985.99.99 0 0 1 1 .985.99.99 0 0 1-1 .984zm9.333-.657c0 .18-.15.328-.333.328h-6a.332.332 0 0 1-.333-.328v-.656c0-.18.15-.328.333-.328h6c.183 0 .333.147.333.328v.656zm0-5.25c0 .18-.179.328-.4.328h-6.512l1.346-1.313h5.166c.221 0 .4.148.4.329v.656z",
    fill: "#D3D6E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardListCheckFilled);
export default __webpack_public_path__ + "static/media/icon-clipboard-list-check-filled.eac6471a.svg";
export { ForwardRef as ReactComponent };